import { customElement } from "lit/decorators.js";
import { LitElement } from "lit";
import { SlhCoreI18n } from "@slhuicore/i18n";

/**
 * Internalization component
 * Enables setting of current locale and custom translation sources
 */
@customElement("slh-nav-i18n")
export default class SlhNavI18n extends SlhCoreI18n(LitElement) {}
